import { render, staticRenderFns } from "./ExamWatchTable.vue?vue&type=template&id=0d2fbb96&scoped=true&"
import script from "./ExamWatchTable.vue?vue&type=script&lang=js&"
export * from "./ExamWatchTable.vue?vue&type=script&lang=js&"
import style0 from "./ExamWatchTable.vue?vue&type=style&index=0&id=0d2fbb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2fbb96",
  null
  
)

export default component.exports